import { ALWAYS_ONLINE_BADGE, RIDER_STATUS, onTripLabel } from "../utils/riderStatus";

function Pill({ badge }) {
  return (
    <span className={`inline-flex items-center text-[10px] font-medium px-1.5 py-0.5 rounded-full ${badge.cls}`}>
      <span className={`h-1.5 w-1.5 rounded-full mr-1 ${badge.dot}`} />
      {badge.label}
    </span>
  );
}

/**
 * Free / On a trip / Offline / … for one rider, plus "Always online" when listed. Nothing for an unknown status.
 * Pass the rider to show free seats or a charter on an on-trip badge.
 */
function RiderStatusBadge({ status, alwaysOnline = false, rider = null }) {
  const base = RIDER_STATUS[status];
  if (!base) return null;
  const tripLabel = status === "on_trip" ? onTripLabel(rider) : null;
  const badge = tripLabel ? { ...base, label: tripLabel } : base;
  return (
    <span className="inline-flex items-center gap-1">
      <Pill badge={badge} />
      {alwaysOnline ? <Pill badge={ALWAYS_ONLINE_BADGE} /> : null}
    </span>
  );
}

export default RiderStatusBadge;
